//START GENAI
import { error } from 'common/errors';
import { asyncMarkWrapper } from 'common/instrumentation';
import { MASTERCARD } from 'common/network-partners';
import { getState } from 'orch-communicator/store';

/**
 * Performs unbind operation specifically for Mastercard SRC network only.
 * This function is called when email hash mismatch is detected to prevent
 * cross-user card access while maintaining selective network targeting.
 *
 * @returns Promise that resolves to unbind response or error
 */
export default async function selectiveUnbindMastercard() {
  try {
    //eslint-disable-next-line
    const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
    const idTokens = getState().srcSdks.apiResponseCache.idTokens;

    // Check if Mastercard SDK is available
    if (!vSDK[MASTERCARD]) {
      return null;
    }

    let unbindResponse;

    if (idTokens.idTokens.length > 0) {
      unbindResponse = await asyncMarkWrapper(
        'selective_unbind_mastercard',
        MASTERCARD,
        vSDK[MASTERCARD].unbindAppInstance(idTokens)
      );
    } else {
      unbindResponse = await asyncMarkWrapper(
        'selective_unbind_mastercard',
        MASTERCARD,
        vSDK[MASTERCARD].unbindAppInstance({})
      );
    }

    return unbindResponse;
  } catch (e) {
    return error('AUTH_INVALID', 'Failed to invoke selective unbind for Mastercard');
  }
}
//END GENAI
